import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import MemberContext from './MemberContext';
import RegistryItemGatewayApi from '../services/RegistryItemGatewayApi';

const Context = createContext({
  isDeterminingOutOfStock: true,
  hasOutOfStockItems: false,
});

export default Context;

export const OutOfStockExperimentsContextProvider = ({children}) => {
  // Contexts
  const {memberId, isFetching: isFetchingMember} = useContext(MemberContext);

  // State
  const [isFetchingOutOfStock, setIsFetchingOutOfStock] = useState(true);
  const [hasOutOfStockItems, setHasOutOfStockItems] = useState(null);

  const fetchOutOfStock = useCallback(async id => {
    setIsFetchingOutOfStock(true);

    try {
      const response = await RegistryItemGatewayApi.getRegistryItems({
        memberId: id,
        status: 'out of stock',
        limit: 1,
      });
      setHasOutOfStockItems(!!response.count);
    } catch (error) {
      setHasOutOfStockItems(false);
    }
    setIsFetchingOutOfStock(false);
  }, []);

  // Effects
  useEffect(() => {
    if (isFetchingMember || !memberId) {
      return;
    }

    fetchOutOfStock(memberId);
  }, [memberId, isFetchingMember, fetchOutOfStock]);

  // Locals
  const isDeterminingOutOfStock = isFetchingOutOfStock || isFetchingMember;

  return (
    <Context.Provider
      value={{
        isDeterminingOutOfStock,
        hasOutOfStockItems,
      }}>
      {children}
    </Context.Provider>
  );
};

OutOfStockExperimentsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
